import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router, { handleUnauthorized } from './router'
import vuetify from './plugins/vuetify'
import '@fontsource-variable/bricolage-grotesque'
import '@fontsource-variable/nunito'
import './styles/tokens.css'
import './styles/utilities.css'
import './styles/motion.css'
import './styles/ui.css'
import './styles/dialogs.css'
import { rise } from './directives/rise'
import { initSentry, registerGlobalErrorHandlers } from './utils/sentry'
import { initServiceWorker } from '@/composables/useServiceWorker'
import { logger } from '@/composables/useLogger'
import { setNavigateToLogin } from '@/api/client'
import { useThemeStore } from '@/stores/theme'

logger.info('Application starting', { environment: import.meta.env.MODE })

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)
app.directive('rise', rise)
useThemeStore()

// Initialize Sentry (after router is registered)
initSentry(app, router)
registerGlobalErrorHandlers()

// Wire router navigation for 401 redirects — avoids hard reloads and Pinia state loss
setNavigateToLogin(() => { void handleUnauthorized() })

app.mount('#app')

// Initialize service worker (production only)
initServiceWorker()
